module.exports = __webpack_public_path__ + "img/18.ce8eb9e0.png";